import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledMobileHeaderWrapper = styled('div')`
  display: none;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0 20px 0;
    .text {
      color: ${(props) => props.theme.white};
    }

    .admin-header-item-icon {
      height: 24px;
      width: 24px;
    }

    .mobile-header-item-wrapper {
      display: flex;
      gap: 3px;

      span {
        display: flex;
        align-items: center;
        color: ${(props) => props.theme.white};
      }
    }

    .mobile-header-title {
      font-size: 1rem;
      color: ${(props) => props.theme.white};
    }

    &:has(> :only-child) {
      justify-content: center;
    }
  }
`;

export const StyledMobilePageTitle = styled('div')`
  display: none;

  @media only screen and (max-width: ${breakpoints.lg}px) {
    display: flex;
    font-size: 1rem;
    color: ${(props) => props.theme.black};
  }
`;
